<template>
  <client-financial-form :client="client" :action="updateClient"/>
</template>
<script>
  import { mapState, mapMutations } from 'vuex';
  import ClientFinancialForm from './ClientFinancialForm';
  import ClientService from 'src/services/ClientService';
  import clientModule from 'src/store/modules/client';

  export default {
    name: 'client-edit',
    components: {
      ClientFinancialForm
    },
    computed: {
      ...mapState({
        client: state => state.client.currentClient
      })
    },
    methods: {
      ...mapMutations('client', [clientModule.types.SET_CURRENT_CLIENT]),
      async updateClient(id, data) {
        let res = await ClientService.update(id, data);
        this[clientModule.types.SET_CURRENT_CLIENT](res.data);
      }
    }
  }
</script>
<style>
</style>
